import ModelApi from "./ModelApi"

export default class ModelWithFacilityApi extends ModelApi {
    list(facility, onSuccess, onError) {
		this.Get(
			this.baseUrl + `?facility=${facility.split("/").slice(-2)[0]}`,
			onSuccess,
			onError,
		);
	}
}